/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import _forEach from 'lodash/forEach';
import bnd3Service from '../../../services/bnd3.service';
import temperatureStripService from './temperatureStrip.service';
import windStripService from './windStrip.service';
import routeCeilingChartService from './ceilingChart.service';
import routePrecepitationChartService from './precepitationChart.service';
import xAxisService from './xAxis.service';
import routeTrackLineService from './trackLine.service';
import { is_iphone } from '../../../services/utils/is_iphone';
import { is_ipad } from '../../../services/utils/is_ipad';
import utilityService from '../../../services/utility.service';
import ChartConst from '../../../constants/chart.constant';
import AppConst from '../../../constants/app.constant';
import EventConst from '../../../constants/event.constant';
import DefConst from '../../../constants/def.constant';
import bnChartDataProcessService from '../../../services/chartDataProcess.service';
import routeProfileService from '../../../views/Routeprofile/Routeprofile.service';
import Emitter from '../../../bus';
import d3 from '../../../globalexports/d3.export';
import router from '../../../router';
import * as LayerUpdateTimeService from '../../../services/layerUpdateTime/layerUpdateTime.service';

const routeprofileChartService = function () {
  const content = {};
  content.chartApi = {};
  content.chartData = null;
  content.completeData = null;
  content.chartAloftData = null;
  content.noDataFoundText = ChartConst.noDataFoundRouteMessage;
  content.chartNoDataForAloftAvailable = null;
  content.settings = null;
  content.cleanRouteProfileChart = function () {
    // content.settings = scope.settings;
    d3.selectAll('#routeProfileChartContainer svg').remove();
    d3.selectAll('#routeProfileChartContainer #aloft-canvas-container-route').remove();
    d3.selectAll('#routeprofileChartContainer #staticchart-canvas-container-route').remove();
  };
  content.showHideNoData = function (show) {
    if (show) {
      d3.select('#routeprofileNoDataMessage').style('display', 'block');
      d3.select('#routeprofileNoDataMessage span').html(content.noDataFoundText);
    } else {
      d3.select('#routeprofileNoDataMessage').style('display', 'none');
    }
  };
  content.showNoDataStrip = function (fullData, settings) {
    content.noDataFoundText = content.getNoDataMessage(fullData, settings);
    content.showHideNoData(true);
    content.cleanRouteProfileChart();
  };
  content.init = function (sourceData, product, aloftData, fullData) {
    let margin;
    let ceilingData;
    let dateFormat;
    let dateFormat2;
    const {
      xAxisAndChartDistance,
    } = ChartConst;
    let preceipitationData;
    let tempertaureData;
    let windData;
    let sliderHeight;
    let allCharts;
    let defaultWindSpeed;
    let windGustSeries;
    const hideBottomAxis = utilityService.hideBottomAxis();
    if (content.settings.timeZone === AppConst.timeZones.local.key) {
      dateFormat = d3.timeFormat(ChartConst.xAxis.formatLocal + ChartConst.GraphConfig.xAxis
        .timePostFix.local);
      dateFormat2 = d3.timeFormat(ChartConst.GraphConfig.xAxis2.format);
      sourceData = bnChartDataProcessService.parseDatesInMode(sourceData, ChartConst.dateMode
        .local);
    } else {
      dateFormat = d3.utcFormat(ChartConst.xAxis.format + ChartConst.GraphConfig.xAxis
        .timePostFix.zulu);
      dateFormat2 = d3.utcFormat(ChartConst.GraphConfig.xAxis2.format);
      // here also using forecast_ts_local because using d3.utcFormat that
      // will convert local to utc itself
      sourceData = bnChartDataProcessService.parseDatesInMode(sourceData, ChartConst.dateMode
        .local);
    }
    const topSpace = utilityService.is_small_device()
      ? ChartConst.GraphConfig.mobileTopSpace
      : ChartConst.GraphConfig.topSpace;
    margin = is_iphone()
      ? ChartConst.GraphConfig.marginMobile
      : ChartConst.GraphConfig.margin;
    margin = is_ipad()
      ? ChartConst.GraphConfig.marginIPad
      : margin;
    margin.left = utilityService.getSafeAreaPadding().left;
    margin.right = utilityService.getSafeAreaPadding().right;
    if (hideBottomAxis) {
      margin.right += utilityService.getSliderHeight();
    }
    // yAxisLeftWidthOffset = is_ipad()
    //     ? ChartConst.yAxisLeftWidthiPad
    //     : ChartConst.yAxisLeftWidth;
    const flightDots = is_iphone()
      ? ChartConst.flightDotsMobile
      : ChartConst.flightDots;
    if (!sourceData) {
      return;
    }
    // Below logic will make sure that large screen tablets like
    // iPad PRO use same bard config as of for desktop screens
    if (is_iphone()) {
      defaultWindSpeed = ChartConst.windSpeed.mobileLight;
    } else if (is_ipad()) {
      defaultWindSpeed = ChartConst.windSpeed.tabletLight;
    } else {
      defaultWindSpeed = ChartConst.windSpeed.light;
    }
    sliderHeight = utilityService.getFooterHeight() + utilityService.iPhoneXFooterExtraOffset();
    // ChartConst.sliderContainerHeight;
    if (!hideBottomAxis && content.settings.sliderPinned) {
      sliderHeight += utilityService.getSliderHeight();
    }
    const svgWidth = window.innerWidth - (utilityService.is_small_device()
      ? 0
      : parseFloat(AppConst.sideMenuWidth));
    const svgHeight = window.innerHeight - utilityService.getHeaderHeight();
    const width = svgWidth - margin.left - margin.right;
    const majorContainerHeight = svgHeight - (sliderHeight);
    // Creating SVG Container Element
    const svg = d3.select('#routeProfileChartContainer').append('svg')
      .attr('id', 'svgRouteProfileChartContainer')
      .attr('preserveAspectRatio', 'xMinYMin meet')
      .attr('viewBox', `0 0 ${svgWidth} ${svgHeight}`) // class to make it responsive
      .classed('svg-content-responsive', true);

    d3.select('#routeProfileChartContainer').style('height', `${svgHeight - sliderHeight}px`);
    const bncharts = svg.append('g').attr('id', 'routestaticback').classed(
      'bnchartsroute',
      true,
    );

    bncharts.append('text').text('Bn Chart Reference').attr('id', 'bntextrefroute').attr('class', 'ref-text');
    bncharts.append('text').text('77% RLH').attr('id', 'bn-overlap-textref-route').attr(
      'class',
      'ref-text',
    );
    bncharts.append('text').text(() => {
      if (content.settings.maximumAltitudeAllowed <= 12000) {
        return '100%';
      }
      return 'FL200';
    }).attr('id', 'bnxtickRefRoute').attr('class', 'ref-text');

    const bnxtickRefRoute = bnd3Service.getSelectionWidth(d3.select('#bnxtickRefRoute'));
    // yAxisRectWidth = bnxtickRefRoute + 4;
    const normalTextHeight = bnd3Service.getSelectionHeight(d3.select('#bntextrefroute'));
    const bnOverlapTextRefWidth = bnd3Service.getSelectionWidth(d3.select(
      '#bn-overlap-textref-route',
    ));

    const yAxisRectWidth = bnxtickRefRoute + (defaultWindSpeed.arrowWidth / 2) + ChartConst
      .yLeftOffsetToHandleTooltip;
    const yAxisRightRectWidth = Math.max(defaultWindSpeed.arrowWidth, bnOverlapTextRefWidth
      / 2);
    const flightWeatherStripHeight = ((flightDots.radius * 2) + (flightDots.strokeWidth * 2)
      + 2);
    const rulesetStripHeight = ((flightDots.radius * 2) + (flightDots.strokeWidth * 2) + 2);
    const xAxisTopContainerHeight = (normalTextHeight * 3) + xAxisAndChartDistance;
    const xAxisBottomContainerHeight = hideBottomAxis
      ? 0
      : (normalTextHeight * 2) + xAxisAndChartDistance;
    // xAxisBottomContainerHeight = 0;
    let temperatureStripHeight = (normalTextHeight * (hideBottomAxis
      ? 1
      : 2)) + (hideBottomAxis
      ? 0
      : xAxisAndChartDistance); // + (utilityService.is_small_device() ? 1 : -3);
    if (hideBottomAxis) {
      temperatureStripHeight = 0;
    }
    // XAxis bottom container
    const yAxisRectHeight = majorContainerHeight - xAxisTopContainerHeight
      - xAxisBottomContainerHeight - flightWeatherStripHeight - temperatureStripHeight - (
      hideBottomAxis
        ? 0
        : topSpace);
    const yAxisRectY = xAxisTopContainerHeight + flightWeatherStripHeight;

    const totalSizeAvailable = majorContainerHeight - (xAxisTopContainerHeight
      + xAxisBottomContainerHeight + (topSpace / 2) + (hideBottomAxis
      ? 0
      : ((topSpace / 2) + (topSpace / 2))) + temperatureStripHeight + rulesetStripHeight
      + flightWeatherStripHeight);
    const chartHeight = (totalSizeAvailable * (100 - (hideBottomAxis
      ? 0
      : ChartConst.routeCeilingChartPercent)))
      / 100; // chart size will be 28% of total available size
    const bigChartHeight = ((totalSizeAvailable * (hideBottomAxis
      ? 100
      : ChartConst.routeCeilingChartPercent)) / 100);

    const ceilingChartY = xAxisTopContainerHeight + flightWeatherStripHeight
      + rulesetStripHeight;
    const filteredObj = routeProfileService.filterOutOverlappingAirport(
      sourceData,
      bnChartDataProcessService.getAxis(
        width,
        bigChartHeight, (
          bnOverlapTextRefWidth / 2),
        content.settings.timeZone,
      ),
      bnOverlapTextRefWidth,
      content.settings,
      aloftData,
    );
    if (filteredObj.aloftFromMap && filteredObj.filteredRoute && filteredObj.aloftFromMap
      .length === filteredObj.filteredRoute.length) {
      aloftData = filteredObj.aloftFromMap;
    }
    // if (!aloftData && !filteredObj.aloftCacheNotAvailable) {
    //     return;
    // }
    const ceilingMaxValue = content.settings.maximumAltitudeAllowed;
    const ceilingMinValueAllowed = ChartConst.ceilingDomain.min;
    const linearScaleTicks = utilityService.getLinearTicks(
      ceilingMinValueAllowed,
      ceilingMaxValue,
      content.settings,
    );
    _forEach(sourceData, (item) => {
      if (content.settings.temperatureUnit === AppConst.temperatureUnits.fahrenheit.key) {
        item.tmp_display_value = item.tmp_fahrenheit;
      } else {
        item.tmp_display_value = item.tmp_celsius;
      }
    });
    sourceData = filteredObj.filteredRoute;
    d3.select('#routeProfileChartContainer').append('div')
      .attr('id', 'staticchart-canvas-container-route');
    d3.select('#routeProfileChartContainer').append('div')
      .attr('id', 'aloft-canvas-container-route')
      .style('margin-left', `${margin.left}px`);
    const trendSvg = d3.select('#routeProfileChartContainer').append('svg')
      .attr('preserveAspectRatio', 'xMinYMin meet')
      .attr('viewBox', `0 0 ${svgWidth} ${svgHeight}`) // class to make it responsive
      .classed('svg-content-responsive', true);
    const majorContainer = bncharts.append('g').attr('id', 'main-container-route');
    majorContainer.append('rect')
      .attr('class', 'major-box')
      .attr('x', margin.left)
      .attr('y', 0)
      .attr('width', width)
      .attr('height', majorContainerHeight);

    majorContainer.append('rect')
      .attr('class', 'y-axis-background')
      .attr('id', 'y-axis-rect-left')
      .attr('x', margin.left)
      .attr('y', yAxisRectY)
      .attr('width', yAxisRectWidth)
      .attr('height', yAxisRectHeight);

    majorContainer.append('rect')
      .attr('class', 'y-axis-background')
      .attr('x', (width - yAxisRightRectWidth) + margin.left)
      .attr('y', yAxisRectY)
      .attr('width', yAxisRightRectWidth)
      .attr('height', yAxisRectHeight);

    // XAxis top container
    const xAxisTopContainer = trendSvg.append('g').attr('id', 'xAxisTopContainerRoute')
      .attr('transform', () => `translate(${margin.left},${normalTextHeight - 2})`);

    const xAxisBottomContainerY = majorContainerHeight - ((normalTextHeight * 2)
      + xAxisAndChartDistance);
    const xAxisBottomContainer = trendSvg.append('g').attr('id', 'xAxisBottomContainerRoute')
      .attr('transform', () => `translate(${margin.left},${xAxisBottomContainerY})`);
    // Positioning progressbar inside ceiling chart
    d3.select('.progress-bar-container')
      .style('margin-top', `${ceilingChartY + ChartConst.aloftProgressBar.topShift}px`)
      .style('padding', `0 ${yAxisRectWidth + ChartConst.aloftProgressBar.leftRightPadding}px`);
    const routeCeilingChart = bncharts.append('g')
      .attr('id', 'route-ceiling-chart')
      .attr('use-big-height', 'true')
      .attr('transform', () => {
        const x = margin.left;
        const y = ceilingChartY;
        return `translate(${x},${y})`;
      });

    // This is a measurement audit line
    // bncharts.append("line").classed("measureLine", true)
    //     .attr("x1", 500)
    //     .attr("y1", function (d, key) {
    //         return 0;
    //     })
    //     .attr("x2", 500)
    //     .attr("y2", function (d) {
    //         return majorContainerHeight - xAxisTopContainerHeight -
    // (topSpace / 2) - temperatureStripHeight - (topSpace / 2) ;
    //     });

    const routePrecepitationY = ceilingChartY + bigChartHeight + (topSpace
      / 2); // tempStripY - chartHeight - normalTextHeight - xAxisAndChartDistance;
    const routePrecepitationChart = bncharts.append('g')
      .attr('id', 'route-precepitation-chart')
      .attr('transform', () => {
        const x = margin.left;
        const y = routePrecepitationY;
        return `translate(${x},${y})`;
      });

    const tempStripY = routePrecepitationY + chartHeight + (topSpace / 2)
      + normalTextHeight;

    const routeTemperatureStrip = bncharts.append('g')
      .attr('id', 'route-temperature-strip')
      .attr('transform', () => {
        const x = margin.left;
        const y = tempStripY;
        return `translate(${x},${y})`;
      });

    const routeWindStrip = bncharts.append('g')
      .attr('id', 'route-wind-strip')
      .attr('transform', () => {
        const x = margin.left;
        const y = routePrecepitationY - (topSpace / 2) - (ChartConst.GraphConfig.trackLine
          .tooltipDataCircleRadius / 2);
        return `translate(${x},${y})`;
      });

    const xAxisMargin = yAxisRectWidth - 4;
    // Defining chart axis
    const ceilingChartAxis = bnChartDataProcessService.getAxis(
      width,
      bigChartHeight,
      xAxisMargin,
      content.settings.timeZone,
      null,
      yAxisRightRectWidth,
    );
    const precepitationChartAxis = bnChartDataProcessService.getAxis(
      width,
      chartHeight,
      xAxisMargin,
      content.settings.timeZone,
      null,
      yAxisRightRectWidth,
    );
    const windStripAxis = bnChartDataProcessService.getAxis(
      width,
      chartHeight,
      xAxisMargin,
      content
        .settings.timeZone,
      null,
      yAxisRightRectWidth,
    );
    const temperatureStripAxis = bnChartDataProcessService.getAxis(
      width,
      chartHeight,
      xAxisMargin,
      content.settings.timeZone,
      null,
      yAxisRightRectWidth,
    );
    const flightWeatherStripY = (flightWeatherStripHeight + xAxisTopContainerHeight) - 2;
    const flightWeatherStrip = trendSvg.append('g')
      .attr('id', 'flightweather-strip-route')
      .attr('transform', () => {
        const x = margin.left;
        const y = flightWeatherStripY;
        return `translate(${x},${y})`;
      });
    const flightRuleStripY = rulesetStripHeight + flightWeatherStripHeight
      + xAxisTopContainerHeight;
    const flightRuleStrip = bncharts.append('g').attr('id', 'flightrules-strip-route')
      .attr('transform', () => {
        const x = margin.left;
        const y = flightRuleStripY;
        return `translate(${x},${y})`;
      });
    // Creating marker for barb head
    bncharts.append('defs')
      .append('marker')
      .attr('id', 'route-barbheadLight')
      .attr('orient', ChartConst.barbhead.light.orient)
      .attr('markerHeight', ChartConst.barbhead.light.markerHeight)
      .attr('markerWidth', ChartConst.barbhead.light.markerWidth)
      .attr('refX', ChartConst.barbhead.light.refX)
      .attr('refY', ChartConst.barbhead.light.refY)
      .append('path')
      .attr('d', 'M0, 0 V4 L6, 2 Z')
      .attr('fill', defaultWindSpeed.color);
    if (sourceData.length > 1) {
      // Draw x-axis top
      xAxisService.drawXaxis(
        sourceData,
        flightRuleStrip,
        flightWeatherStrip,
        flightWeatherStripHeight,
        xAxisTopContainer,
        xAxisTopContainerHeight,
        xAxisBottomContainerHeight,
        width,
        ceilingChartAxis.x,
        dateFormat,
        dateFormat2,
        flightDots,
        hideBottomAxis,
        yAxisRectWidth,
        majorContainerHeight,
        majorContainer,
        content.settings,
        true,
        content.softDraw,
      );
      if (!hideBottomAxis) {
        // Draw x-axis bottom
        if (content.settings.sliderPinned || !content.softDraw) {
          xAxisService.drawXaxis(
            sourceData,
            flightRuleStrip,
            flightWeatherStrip,
            flightWeatherStripHeight,
            xAxisBottomContainer,
            xAxisTopContainerHeight,
            xAxisBottomContainerHeight,
            width,
            ceilingChartAxis.x,
            dateFormat,
            dateFormat2,
            flightDots,
            hideBottomAxis,
            yAxisRectWidth,
            majorContainerHeight,
            majorContainer,
            content.settings,
            false,
            content.softDraw,
          );
        }
      }
      content.settings.product = product;
      // Draw celeing chart
      ceilingData = bnChartDataProcessService.getCigVisChartData(sourceData, DefConst.xAxisKey
        .arrivalTime, content.settings, true);
      ceilingData = routeCeilingChartService.drawChart(
        sourceData,
        ceilingData,
        routeCeilingChart,
        bigChartHeight,
        width,
        ceilingChartAxis.x,
        ceilingChartAxis.y1,
        ceilingChartAxis.y2,
        topSpace,
        ceilingMaxValue,
        linearScaleTicks,
        yAxisRectWidth,
        yAxisRightRectWidth,
        aloftData,
        content.settings,
        fullData,
      );
      // Draw Wind strip
      windData = bnChartDataProcessService.getWdrWspXwdChartData(sourceData, DefConst.xAxisKey
        .arrivalTime, content.settings);

      // BNFOR-301 removing this wind strip
      windStripService.drawWindStrip(
        sourceData,
        windData,
        routeWindStrip,
        windStripAxis.x,
        DefConst.xAxisKey.arrivalTime,
      );
      // Draw preceipitation chart
      preceipitationData = bnChartDataProcessService.getP06Q06t06st6ChartData(
        sourceData,
        DefConst.xAxisKey.arrivalTime,
        content.settings,
      );
      if (!hideBottomAxis) {
        routePrecepitationChartService.drawChart(
          sourceData,
          preceipitationData,
          routePrecepitationChart,
          chartHeight,
          width,
          topSpace,
          precepitationChartAxis.x,
          precepitationChartAxis.y1,
          precepitationChartAxis.y2,
        );
      }
      if (content.settings.sliderPinned || !content.softDraw || hideBottomAxis) {
        // Draw temperature chart strip
        tempertaureData = bnChartDataProcessService.getTmpRlhChartData(sourceData, DefConst
          .xAxisKey.arrivalTime, content.settings);
        temperatureStripService.drawTemperatureStrip(
          sourceData,
          routeTemperatureStrip,
          width,
          topSpace,
          temperatureStripAxis.x,
          xAxisAndChartDistance,
          content.settings.temperatureUnit,
          normalTextHeight,
          DefConst.xAxisKey.arrivalTime,
          false,
          content.softDraw,
        );
        if (windData) {
          _forEach(windData, (obj) => {
            if (obj.key === ChartConst.ChartLabelSpecs.wsp.key) {
              obj.group = 1;
            }
          });
          if (windData[0]) {
            windData[0].group = 1;
          }
          if (windData[1]) {
            windData[1].group = 1;
          }
        }
        if (windData[0]) {
          ceilingData.push(windData[0]);
        }
        if (windData[1]) {
          ceilingData.push(windData[1]);
        }
        if (product === ChartConst.products.lamp.name) {
          windGustSeries = bnChartDataProcessService.getSeriesByKey(windData, ChartConst
            .ChartLabelSpecs.wgs.key);
          if (windGustSeries) {
            windGustSeries.group = 1;
            ceilingData.push(windGustSeries);
          }
        }
      }
      // Adding Chart Label
      bnd3Service.addChartLabels(routeCeilingChart, normalTextHeight, width, ChartConst
        .chartLabels.ceiling);
      if (!hideBottomAxis) {
        bnd3Service.addChartLabels(routePrecepitationChart, normalTextHeight, width, ChartConst
          .chartLabels.precepitation);
      }

      bnd3Service.addNoSeriesDataText(
        routePrecepitationChart,
        preceipitationData,
        chartHeight,
        width - yAxisRectWidth - yAxisRightRectWidth,
        yAxisRectWidth,
        ChartConst.chartLabels
          .precepitation.noSeriesLabel,
      );
      bnd3Service.addNoSeriesDataText(
        routeCeilingChart,
        ceilingData,
        bigChartHeight,
        width - yAxisRectWidth - yAxisRightRectWidth,
        yAxisRectWidth,
        ChartConst
          .chartLabels.ceiling.noAloftData,
        true,
      );
      // Use this data for tracking line implementation
      allCharts = {
        ceilingChart: {
          data: ceilingData,
          axisInfo: ceilingChartAxis,
        },
        precepitationChart: {
          data: preceipitationData,
          axisInfo: precepitationChartAxis,
        },
        windChart: {
          data: windData,
          axisInfo: windStripAxis,
        },
        tempChart: {
          data: tempertaureData,
          axisInfo: temperatureStripAxis,
        },
      };
      routeTrackLineService.drawTrackLine(
        content.settings,
        majorContainerHeight,
        chartHeight,
        width,
        allCharts,
        sourceData,
        topSpace,
        margin,
        ceilingChartY,
        bigChartHeight,
        rulesetStripHeight,
        flightWeatherStripHeight,
        xAxisBottomContainerHeight,
        xAxisTopContainerHeight,
        yAxisRectHeight,
        temperatureStripHeight,
        yAxisRectWidth,
        yAxisRightRectWidth,
        aloftData,
        ceilingChartAxis,
        trendSvg,
        ceilingMaxValue,
        ceilingMinValueAllowed,
        fullData,
        content.softDraw,
      );
    }
    // Some common task that needs to be performed on bncharts
    bnd3Service.processChartComponents(
      bncharts,
      chartHeight,
      margin,
      svgHeight,
      width,
      yAxisRectWidth,
      bigChartHeight,
      yAxisRightRectWidth,
    );
    // bnd3Service.shiftLines(routeCeilingChart, ChartConst.areaLineShift.normal);

    LayerUpdateTimeService.setCurrentScreenRenderTime();
  };
  content.processData = function (data, fullData) {
    if (data.length && data.length > 1) {
      content.showHideNoData(false);
      content.chartData = data;
      content.fullDataRoute = fullData;
      content.init(content.chartData, content.chartData[0].flightMode, null, fullData);
    } else {
      content.showHideNoData(true);
    }
  };
  content.startRendering = function (data, fullData) {
    // settings = scope.settings;
    if (data) {
      content.cleanRouteProfileChart();
      content.processData(data, fullData);
    }
  };
  // Call this function too redraw the chart

  content.chartApi.refresh = function (data, fullData, softDrawValue, settings) {
    content.settings = settings;
    // if ($state.current.name === "app.routeprofile") {
    content.softDraw = softDrawValue;
    content.startRendering(data, fullData);
    // }
  };
  Emitter.on(EventConst.routeAloftReady, (data) => {
    // Checking user is still on routeProfile screen
    if (router.currentRoute.value.name === 'app.routeprofile' && data && content.chartData) {
      if (data && data.length === 0) {
        d3.select('#route-ceiling-chart .no-aloft-to-show').classed('show-message', true);
        return;
      }
      d3.select('#route-ceiling-chart .no-aloft-to-show').classed('show-message', false);

      const depart = content.chartData[0];
      const dest = content.chartData[content.chartData.length - 1];
      const aloftDepart = data[0];
      const aloftDest = data[data.length - 1];
      // This condition will make sure that if user changes any settings
      // like start, end or departureTime
      // Before previous aloft data is complete then it will not draw using old data
      if ((aloftDepart.arrival_time.getTime() === depart.arrival_time.getTime())
        && (aloftDest.arrival_time.getTime() === dest.arrival_time.getTime())
        && (aloftDepart.icao_id === depart.icao_id)
        && (aloftDest.icao_id === dest.icao_id)) {
        routeTrackLineService.detachtrendlineEvents();
        content.cleanRouteProfileChart();
        content.init(
          content.chartData,
          content.chartData[0].flightMode,
          data,
          content.fullDataRoute,
        );
      }
    }
  });
  return content;
};
export default routeprofileChartService();
